import { toast } from 'react-toastify';

export function successNotification(message, options = {}) {
    toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        ...options,
    });
}

export function errorNotification(message, options = {}) {
    toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        isMobile: true,
        breakpoint: 600,
        ...options,
    });
}

export function formSuccessNotification(message, options = {}) {
    toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        ...options,
    });
}

export function formErrorNotification(message, options = {} ) {
    toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        ...options,
    });
}

export function LoadingToast(message, options = {}) {
    return toast.loading(message, {
        isLoading: true,
        hideProgressBar: true,
        ...options,
    });
}

export function UpdateToastSuccess(message, toastId, options = {}) {
    toast.update(toastId, {
        render: message,
        position: "top-right",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        ...options,
    });
};

export function UpdateToastFailed(message, toastId, options = {}) {
    toast.update(toastId, {
        render: message,
        position: "top-right",
        isLoading: false,
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        ...options,
    })
}